import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BtnGoBack from "../../../components/common/btnGoBack";
import CheckList from "../../../components/schedule/setting/checkList";

import CountCourse from "../../../components/schedule/setting/countCount";
import EditList from "../../../components/schedule/setting/editList";
import ResetSendList from "../../../components/schedule/setting/resetSendList";
import scheduleService from "../../../services/schedule.service";
import settingScheduleService from "../../../services/settingSchedule.service";
type ParamType = {
  sche: string;
};

const SettingSchedule = () => {
  const Param = useParams<ParamType>();

  const [curriList, setCurriList] = useState([]);
  const [schedule, setSchedule] = useState<any>({});

  useEffect(() => {
    (async () => {
      await scheduleService.getById(Number(Param.sche)).then((res) => {
        setSchedule(res.data);
        settingScheduleService
          .getCurriForSetting(res.data.type)
          .then((curri) => {
            // console.log(curri);
            setCurriList(curri.data);
          });
      });
    })();
  }, [Param.sche]);

  let typeDoc = schedule.type === "mhesi" ? "อชว." : "มคอ.";
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">
          กำหนดรายวิชาที่ต้องส่งเอกสาร {typeDoc} | RMUTI
        </h3>
        <div className="row mt-3">
          <div className="col text-start">
            <div className="p-3 pt-4 mb-3 alert alert-primary text-center">
              <h4>
                กำหนดการส่งเอกสาร {typeDoc} | RMUTI ประจำปีการศึกษา{" "}
                {schedule.year} ภาคการศึกษาที่ {schedule.term}
              </h4>
              <div className="row">
                <div className="col">
                  กำหนดส่ง {typeDoc}3 | R-1 วันที่{" "}
                  {moment(schedule.doc3).add(543, "year").format("D/MM/YYYY")}
                </div>
                <div className="col">
                  กำหนดส่ง {typeDoc}5 | R-2 วันที่{" "}
                  {moment(schedule.doc5).add(543, "year").format("D/MM/YYYY")}
                </div>
              </div>
            </div>{" "}
          </div>
        </div>

        <h5 className="text-start mt-2">
          เลือกหลักสูตรที่ต้องการตั้งค่ารายวิชา {typeDoc} | RMUTI
        </h5>

        <table className="table table-hover table-responsive">
          <thead className="table-dark">
            <tr>
              <th>ชื่อย่อ</th>
              <th>ชื่อหลักสูตร</th>
              <th>ระดับ</th>
              <th style={{ width: "10%" }}>จำนวนรายวิชาที่ต้องส่ง</th>
              <th style={{ width: "15%" }}>Handle</th>
            </tr>
          </thead>
          <tbody>
            {!(curriList.length > 0) && (
              <tr>
                <td colSpan={5}>ไม่พบ</td>
              </tr>
            )}
            {curriList.length > 0 &&
              curriList.map((d: any) => {
                return (
                  <tr key={d.id}>
                    {/* <td colSpan={5}>บ่พบ</td> */}
                    <td>{d.shortName}</td>
                    <td>{d.name}</td>
                    <td>{d.level}</td>
                    <td>
                      <CountCourse schedule={schedule.id} curri={d} />
                    </td>
                    <td>
                      <CheckList
                        schedule={schedule.id}
                        curri={d}
                        type={schedule.type === "tqf" ? `มคอ` : `อชว.`}
                      />
                      {/* แก้ไขต่อตรงนี้ได้ */}
                      <EditList sche={schedule} curri={d} />

                      <ResetSendList sche={schedule} curri={d} />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <BtnGoBack />
      </div>
    </>
  );
};

export default SettingSchedule;
